export default {
  methods: {
    getLocalizedString(stringArray) {
      const string = stringArray.find((string) => {
        return string.locale === this.$i18n.locale;
      });
      return string ? string.content : null;
    },
    validURL(str) {
      var pattern = new RegExp("^(https?://)")
      return !!pattern.test(str);
    },
  },
};
